module.exports = __webpack_public_path__ + "img/rabbit.5d3f855f.png";